import styled from 'styled-components';

export const OptionsContainer = styled.div`
	height: auto;
	min-height: 40px;
	max-height: 200px;
	box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 16px 0px;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	background-color: #f5f7fa;
	overflow-y: scroll;

	::-webkit-scrollbar {
		width: 4px;
	}

	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	::-webkit-scrollbar-thumb {
		background: #888;
	}

	::-webkit-scrollbar-thumb:hover {
		background: #555;
	}

	& > p {
		width: 100%;
		cursor: pointer;

		&:hover {
			background-color: #fff;
			font-weight: 600;
		}
	}
`;

export const AutoCompleteContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 40px;
	gap: 20px;
	grid-gap: 20px;

	& > button {
		height: 40px;
		margin-top: 24px;
	}
`;
